import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { InvoiceTypeEnum, PaymentChannelEnum, PaymentMethodEnum } from "../../data/enums";

export namespace FinanceReportValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                method: v.optional(v.picklist(PaymentMethodEnum.valuesDirect)),
                channel: v.optional(v.picklist(PaymentChannelEnum.values)),
                minDate: v.optional(baseVals.isoDate()),
                maxDate: v.optional(baseVals.isoDate()),
            }),
        }),
    );

    export const GenerateExport = defineValidation(
        v.object({
            invoiceType: v.optional(v.picklist(InvoiceTypeEnum.valuesReport)),
            minDate: v.optional(baseVals.isoDate()),
            maxDate: v.optional(baseVals.isoDate()),
            method: v.optional(v.picklist(PaymentMethodEnum.valuesDirect)),
            channel: v.optional(v.picklist(PaymentChannelEnum.values)),
            account: v.optional(baseVals.string()),
        }),
    );
}
